// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'circle-mixed-left';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path fill='currentColor' d='M9 .864c4.536 0 8.28 3.6 8.28 8.136S13.608 17.136 9 17.136z' />
    <path d='M9 .864C4.392.864.72 4.464.72 9S4.392 17.136 9 17.136z' />
  </g>
);

export const viewBox = '0 0 18 18';
